/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
*/
import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";

export default function Body({ links }) {
  return (
    <>
      <Container fluid id="body-wrapper">
        <Row className="justify-content-center py-3">
          <Col md={6} lg={5} className="text-center">
            <Image
              src={process.env.REACT_APP_SWMC_IMG_CDN + "8am-and-2-hours-logo.png"}
              alt="Thoroughly Reviewed & Underwritten on Demand and Condition Reviewed & Resolved on Demand"
              fluid
              className="amlogo"
            />
          </Col>
        </Row>
        <Row className="justify-content-around">
          <Col lg={5} className="pb-3">
            <Row className="align-items-baseline pb-3">
              <Col xs={2} sm={2}>
                <Image
                  src="https://d2w24n4g34usfg.cloudfront.net/SunWestPartners/images/PartnerBenefits/Morgan-logo.png"
                  alt="AngelAi"
                  className="icons-max-width morgan-icon-padding"
                />
              </Col>
              <Col xs={10} sm={10}>
                <div>
                  <h4 className="fw-bold">{links.brandName}</h4>
                </div>
                <div className="mt-2">
                  <h5>
                    24/7 support from&nbsp;
                    <a
                      href={links.mobileAppURL}
                      target="_blank"
                      className="text-center AngelAilink"
                    >
                      {links.brandName}
                    </a>
                    , Sun West's proprietary Artificial Intelligence. Your
                    personal loan expert on anything and EVERYTHING you could
                    need!
                  </h5>
                </div>
              </Col>
            </Row>
          </Col>
          <Col lg={5} className="pb-3">
            <Row className="align-items-baseline pb-3">
              <Col xs={2} sm={2}>
                <Image
                  src={process.env.REACT_APP_CALLME_CDN_URL + "TRUApproval.png"}
                  alt="TRU Approval®"
                  className="icons-max-width icon-padding"
                />
              </Col>
              <Col xs={10} sm={10}>
                <div>
                  <h4 className="fw-bold">TRU Approval&reg;</h4>
                </div>
                <div className="mt-2">
                  <h5>
                    With minimum conditionally guarantee&nbsp;
                    <a
                      href="https://www.swmc.com/truapproval/"
                      target="_blank"
                      rel="noreferrer noopener"
                      title="TRU Approval®"
                    >
                      TRU Approvals
                    </a>
                    ,&nbsp;your clients can make offers with no loan
                    contingency.
                  </h5>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="justify-content-around">
          <Col lg={5} className="pb-3">
            <Row className="align-items-baseline pb-3">
              <Col xs={2} sm={2}>
                <Image
                  src={
                    process.env.REACT_APP_CALLME_CDN_URL + "Governmentloans.png"
                  }
                  alt="Government Loans with minimum FICO of 500"
                  className="icons-max-width icon-padding"
                />
              </Col>
              <Col xs={10} sm={10}>
                <h4>Government loans with minimum FICO of 500</h4>
              </Col>
            </Row>
          </Col>
          <Col lg={5} className="pb-3">
            <Row className="align-items-baseline pb-3">
              <Col xs={2} sm={2}>
                <Image
                  src={
                    process.env.REACT_APP_CALLME_CDN_URL +
                    "Expansiveproductline.png"
                  }
                  alt="Expansive Product Line"
                  className="icons-max-width icon-padding"
                />
              </Col>
              <Col xs={10} sm={10}>
                <h4>Expansive Product Line</h4>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="justify-content-around">
          <Col lg={5} className="pb-3">
            <Row className="align-items-baseline pb-3">
              <Col xs={2} sm={2}>
                <Image
                  src={
                    process.env.REACT_APP_CALLME_CDN_URL + "245Processing.png"
                  }
                  alt="24/5 Processing and Underwriting"
                  className="icons-max-width icon-padding"
                />
              </Col>
              <Col xs={10} sm={10}>
                <h4>24/5 Processing and Underwriting</h4>
              </Col>
            </Row>
          </Col>
          <Col lg={5} className="pb-3">
            <Row className="align-items-baseline pb-3">
              <Col xs={2} sm={2}>
                <Image
                  src={
                    process.env.REACT_APP_CALLME_CDN_URL +
                    "ManualUnderwriting.png"
                  }
                  alt="Manual Underwriting allowed on FHA, VA, and USDA loans"
                  className="icons-max-width icon-padding"
                />
              </Col>
              <Col xs={10} sm={10}>
                <h4>Manual Underwriting allowed on FHA, VA, and USDA loans</h4>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col className="text-center mb-5">
            <h5>
              Visit{" "}
              <a
                href="https://www.swmc.com/tru-terms"
                className="tru-terms"
                target="_blank"
              >
                swmc.com/tru-terms
              </a>{" "}
              for TRU Approval® terms and conditions.
            </h5>
          </Col>
        </Row>
      </Container>
      <p className="disclaimer">
        {" "}
        Jason Oppenheim is a paid spokesman for{" "}
        <a href="https://celligence.com/" target="_blank">
          Celligence International, LLC
        </a>
        , the creators of {links.brandName}.
      </p>
    </>
  );
}
